import LandingPageLayout from 'components/LandingPageLayout';
import StaysLocation from 'components/LandingPageStaysLocation';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import ClientSlider from 'components/LandingPageCarousels/ClientSlider';
import WhatsAppAboutus from 'components/LandingPageAboutUs/WhatsAppAboutus';
import React from 'react';
import ReservationForm from 'components/LandingPageReservationForm';
import LandingPageWinnipegPays from 'components/LandingPageWinnipegPays';
import Head from 'next/head';
const WinnipegSrStudents = () => {
  const clientsData = [
    {
      id: 1,
      image: 'pivot.png',
      name: 'client-1',
    },
    {
      id: 2,
      image: 'rental.png',
      name: 'client2',
    },
    {
      id: 3,
      image: 'globe.png',
      name: 'client-3',
    },
    {
      id: 4,
      image: 'nationalposts.png',
      name: 'client-4',
    },
    {
      id: 5,
      image: 'toronto.png',
      name: 'client-5',
    },
    {
      id: 6,
      image: 'rental.png',
      name: 'client-6',
    },
  ];
  return (
    <>
      <Head>
        <meta charset="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Winnipeg SR Students</title>
        <meta
          name="description"
          content="Looking for furnished rooms?
 Soul Rooms is the right destination. We provide you 
 with co-living spaces that offer you peace of mind 
 and comfortable stay."
        />
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://www.soulrooms.com/winnipeg-sr-students" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="SIMPLIFIED shared living FOR AWESOME PEOPLE" />
        <meta
          property="og:description"
          content="Looking for
 furnished rooms? Soul Rooms is the right destination.
  We provide you with co-living spaces that offer 
  you peace of mind and comfortable stay."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/stock/107964" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomstoron1" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta name="twitter:description" content="SIMPLIFIED shared living FOR AWESOME PEOPLE" />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/stock/107964" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />
        <meta name="author" content="SoulRooms" />
        <link rel="canonical" href="https://www.soulrooms.com/winnipeg-sr-students" />
      </Head>
      <LandingPageLayout>
        {/* STAY LOCATION SECTION  */}
        <StaysLocation
          img={'/static/images/landingPages/winnipegstdimg.png'}
          title={'RESIDENCES TAILORED TO AWESOME STUDENTS'}
          description={
            <p
              className="  responsiveText pt-xl-1 pb-2 pe-xl-1  "
              style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
              Winnipeg may be a bit cold but our warm luxury rentals make it a great place to study and settle in
              Canada. At soulrooms, we care about where your live, and who you live with, so curate the properties from
              the best landlords that suit your needs.
            </p>
          }
          href="#JotFormIFrame-91797058303261"
          btnTitle={'Find Properties'}
        />
        <LandingPageWinnipegPays
          heading="LIVE, GROW YOUR CAREER AND HAVE THE BEST TIME WHILE YOU STUDY"
          imgSrc1="/static/images/landingPages/winnipeg-student-pay-4.png"
          imgSrc2="/static/images/landingPages/winnipeg-student-pay-5.png"
          imgSrc3="/static/images/landingPages/winnipeg-student-pay-6.png"
          title1="Great Lifestyle & Network"
          title2="Student Ready"
          title3="Right people, Right Stay"
          desc1="Toronto's largest & 
        most trusted community is now in Winnipeg
        ! You get to live in one of the most 
        iconic buildings and networking 
        opportunities with professionals
         from Toronto."
          desc2="Hi-speed internet, study table,
          flat screen, and coffee all you need to 
          have a great start of your school year. 
          Pack your bags and show up at the safest 
          Rooms in Winnipeg."
          desc3="We may not be the cheapest option out
            there, but we are certainly the safest one 
            for students especially when you are traveling 
            from overseas. Our location in Winnipeg has premium 
            building amenities, security and is managed by top 
            managers and landlords in the country. You will subscribe
             to a set of people with the same standard of living where
              you belong. "
          btn1={true}
          btn2={false}
          btn3={false}
          btnTitle1="Learn more"
          href1="/renters"
          reverse2={true}
        />
        <HeadingSection title="AS FEATURED IN:" bgcolor="white" />
        <ClientSlider classN="clients-brand-carousel" clientsData={clientsData} icons={true} />
        <ReservationForm heading="FILL IN YOUR REQUIREMENTS & SEE AVAILABLE OPTIONS">
          <iframe
            id="JotFormIFrame-91797058303261"
            title="Find a SoulRoom"
            onLoad={() => {
              window.parent.scrollTo(0, 0);
            }}
            allowTransparency="true"
            allowFullScreen="true"
            allow="geolocation; microphone; camera"
            src="https://form.jotform.com/91797058303261"
            frameBorder="0"
            style={{ minWidth: '100%', height: '640px', border: 'none' }}
            scrolling="no"></iframe>
        </ReservationForm>
        {/* <WhatsAppAboutus /> */}
      </LandingPageLayout>
    </>
  );
};

export default WinnipegSrStudents;
